<template lang="pug">
.v-contact.contact(v-if="contact")
	a.contact__title(
		v-if="contact.link"
		:href="contact.link.href"
	) {{contact.link.label}}
	.contact__main
		.contact__grid
			.contact__cell.flc
				.contact__region(v-if="contact.region && contact.region.length")
					.contact__region-title РЕГИОН:
					.contact__region-links
						template(v-for="(regionItem, regionItemIndex) in contact.region" :key="regionItemIndex")
							component.contact__region-link.flc(:is="regionItem.active ? 'span' : 'a'" :href="regionItem.link" :class="{'active': regionItem.active}")
								span.contact__region-text {{regionItem.text}}
							span.contact__separator
								span &nbsp;&nbsp;
								span /
								span &nbsp;&nbsp;
				.contact__email(v-if="contact.email && contact.email.length")
					.contact__email-title E-MAIL:
					template(v-for="(emailItem, emailItemIndex) in contact.email" :key="emailItemIndex")
						a.contact__email-link.flc(:href="emailItem.link") {{emailItem.text}}
			.contact__cell.flc(v-if="contact.phone && contact.phone.length")
				.contact__phone-title ТЕЛЕФОНЫ:
				template(v-for="(phoneItem, phoneItemIndex) in contact.phone" :key="phoneItemIndex")
					a.contact__phone-link.flc(:href="phoneItem.link") {{phoneItem.text}}
		.contact__footer(v-if="contact.action")
			button.btn.btn--primary-2.btn--wide.btn--has-right-icon(type="button" @click="goToContactForm")
				.btn__text {{contact.action.text}}
				.btn__icon-wrap
					v-svg-icon.btn__icon.btn__icon--original(icon="arrow-top-right")
					v-svg-icon.btn__icon.btn__icon--copy(icon="arrow-top-right")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			contact: null
		};
	},

	methods: {
		goToContactForm() {
			controller.closeAll();
			let $pageFooter = document.getElementById('page_footer');
			if (!$pageFooter) {
				return;
			}
			setTimeout(() => {
				window.scrollTo({
					top: $pageFooter.offsetTop,
					behavior: 'smooth'
				});
			}, 300);
		},

		dataSet(data) {
			this.contact = data;
		},
	}
};
</script>
